import React from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { useWizard } from "react-use-wizard";
import "./PulseStep.css";

function PulseStep({
  id,
  question,
  question_english,
  answers,
  handleRadioClick,
  value,
  required,
  language,
}) {
  const { nextStep } = useWizard();

  const handleAnswerSelection = (e) => {
    handleRadioClick(id, e.target.value);
    nextStep();
  };

  return (
    <Col className="pulse-step">
      <Col className="center mb-4">
        <h5>{language === "es" ? question : question_english}</h5>
      </Col>
      <Col className="center">
        <Form>
          <Form.Group
            className="align-items-center mb-2 pulse-step-answers"
            controlId="answersRadio"
            onChange={(e) => handleAnswerSelection(e)}
            value={value}
          >
            {answers.map((item) => (
              <Form.Check
                inline={true}
                key={item._id}
                id={item._id}
                type="radio"
                label={
                  language === "es"
                    ? item.description
                    : item.description_english
                }
                name={`group${id}`}
                value={item.description}
                defaultChecked={value === item.description}
              />
            ))}
          </Form.Group>
        </Form>
      </Col>
    </Col>
  );
}

export default PulseStep;
